// extracted by mini-css-extract-plugin
export default {"pagination":"DataTable_pagination__zxQdB","paginationItem":"DataTable_paginationItem__kZyry","paginationInfo":"DataTable_paginationInfo__ylz2+"};